export const MetricTypes = {
  REQUEST: "request",
  RESPONSE: "response",
  ERROR: "error",
  RETRY: "retry",
}
